const MIN_PASSWORD_LENGTH = 7;
const LETTER_REGEX = /[A-Za-z]/;
const NUMBER_REGEX = /[0-9]/;
const SPECIAL_CHAR_REGEX = /[!@#$%^&*(),.?":{}|<>]/;

export const getPasswordRequirementStatus = (password: string) => {
  const hasLetter = LETTER_REGEX.test(password);
  const hasNumber = NUMBER_REGEX.test(password);

  return {
    minLength: password.length >= MIN_PASSWORD_LENGTH,
    hasLetterAndNumber: hasLetter && hasNumber,
    hasSpecialChar: SPECIAL_CHAR_REGEX.test(password),
  };
};

export const getPasswordValidationErrors = (password: string): string | null => {
  const { minLength, hasLetterAndNumber, hasSpecialChar } = getPasswordRequirementStatus(password);

  if (!minLength) {
    return 'errors.passwordTooShort';
  }
  if (!hasLetterAndNumber) {
    return 'errors.passwordMissingNumberOrLetter';
  }
  if (!hasSpecialChar) {
    return 'errors.passwordMissingSpecialChar';
  }

  return null;
};
